import "../../css/MissionControll.css";
import { useDispatch, useSelector } from "react-redux";
import MissionControlMapGM from "../../components/maps/MissionControl/MissionControlMapGM";
import MissionControlMapOS from "../../components/maps/MissionControl/MissionControlMapOS";
import { DirectionsRendererProvider } from "../../context/DirectionRendererContext";
import missionControlLogo from "../../assets/mission-control-logo.png";
import { X } from "react-feather";
import React from "react";
import { useNavigate } from "react-router-dom";
import { missionControlActions } from "../../store/mission-control/mission-control-slice";

const MissionControl = () => {
  const mapSettings = useSelector((state) => state.missionControl.mapSettings);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return (
    <DirectionsRendererProvider>
      <div className="mission-control">
        <X
          onClick={() => {
            dispatch(missionControlActions.resetMissionControl());
            navigate("/");
          }}
          className="mission-control-close"
        />
        {mapSettings.map === 1 ? (
          <MissionControlMapGM />
        ) : (
          <MissionControlMapOS />
        )}
      </div>
      <div className="mission-control-logo">
        <img
          src={missionControlLogo}
          alt={"mission control"}
          className="mission-control-logo-image"
        />
      </div>
    </DirectionsRendererProvider>
  );
};

export default MissionControl;
